// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".input-modal .vm--modal{padding:24px}.input-modal__header{align-items:center;display:flex;justify-content:space-between;padding-bottom:24px}.input-modal__close{background:transparent;border:0;cursor:pointer}.input-modal__button{margin-left:auto;margin-top:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
